import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from '../content/header_text.png';
import './HeaderText.css';

/** From Figma — «НАГРАДЫ», top 145.5 / left 400. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="stickers-header-text"
      src={headerTextImg}
      alt="Награды"
    />
  );
}
